import { useAppInfo } from "@src/mobile/hooks/useAppInfo";

import { AppInfoSectionView } from "./AppInfoSectionView";

export function AppInfoSectionContainer() {
  const appInfo = useAppInfo();

  return <AppInfoSectionView {...appInfo} />;
}
